import { NgModule } from 'ng-metadata/core';
import { LoaderComponent } from './loader.component';

/**
 * @ngdoc module
 * @name mw.components.loader
 * @description
 *
 * Loaders
 */
@NgModule({
    declarations: [ LoaderComponent ]
})
export class LoaderModule {}



// WEBPACK FOOTER //
// ./src/lib/components/loader/loader.module.ts